import { useEffect, useState } from 'react'
import api from '../services/api'

let cachedVersion = null
let inflight = null

export function useVersion() {
  const [version, setVersion] = useState(cachedVersion)

  useEffect(() => {
    if (cachedVersion) {
      setVersion(cachedVersion)
      return
    }

    if (!inflight) {
      inflight = api.get('/api/version')
        .then((res) => {
          cachedVersion = res.data
          setVersion(res.data)
        })
        .catch((err) => {
          console.error('Erro ao buscar versão', err)
        })
        .finally(() => {
          inflight = null
        })
    } else {
      inflight
        .then(() => cachedVersion && setVersion(cachedVersion))
        .catch(() => {})
    }
  }, [])

  return version
}
